import { render } from "./MeuPerfilModal.vue?vue&type=template&id=52044d2a&scoped=true"
import script from "./MeuPerfilModal.vue?vue&type=script&lang=js"
export * from "./MeuPerfilModal.vue?vue&type=script&lang=js"

import "./MeuPerfilModal.vue?vue&type=style&index=0&id=52044d2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52044d2a"]])

export default __exports__